export default __webpack_public_path__ + "static/media/onixath.da1826f2.svg";